export default {
  common: {
    locale: 'pl-PL',
    localeShort: 'pl',
    company: 'Spółka',
    companies: 'Spółki',
    authorized: 'Upoważnieni',
    team: 'Zespół',
    teams: 'Zespoły',
    budget: 'Budżet',
    budgetTooltip:
      'Budżet to <strong>identyfikator grupy kontrahentów powiązanych jedną umową - nie jest to kwota pieniędzy</strong>. Wskazuje, do jakiego klienta i jakiej spółki należy kampania.',
    client: 'Kontrahent',
    clients: 'Kontrahenci',
    profile: 'Profil',
    currency: 'Waluta',
    employee: 'Pracownik',
    employees: 'Pracownicy',
    user: 'Użytkownik',
    year: 'Rok',
    month: 'Miesiąc',
    monthShort: 'm-c',
    monthShort2: 'm-ce',
    monthShort6: 'm-cy',
    above: 'powyżej',
    status: 'Status',
    lp: 'L.p.',
    name: 'Nazwa',
    shortname: 'Skrót',
    description: 'Opis',
    sysNumber: 'Nr sys.',
    sysNumberLowerCase: 'nr sys.',
    oneToolId: 'OneTool ID',
    history: 'Historia',
    lastModification: 'Ostatnia modyfikacja',
    who: 'Kto',
    when: 'Kiedy',
    noInformation: 'Brak informacji',
    creation: 'Utworzenie',
    activeShe: 'Aktywna',
    activeHe: 'Aktywny',
    nonActiveHe: 'Nieaktywny',
    nonActiveShe: 'Nieaktywna',
    yes: 'Tak',
    no: 'Nie',
    yesUpperCase: 'TAK',
    noUpperCase: 'NIE',
    notDefined: 'ND',
    partly: 'Częściowo',
    sumUpperCase: 'SUMA',
    sum: 'Suma',
    creator: 'Autor',
    creationDate: 'Data utworzenia',
    emails: 'Adresy e-mail',
    noData: 'Brak danych',
    downloadDocs: 'Pobierz dokumenty',
    selectMonth: 'Wybierz miesiąc',
    positionName: 'Nazwa pozycji',
    country: 'Państwo',
    purchaser: 'Zamawiający',
    brand: 'Brand',
    profilePosition: 'Pozycja profilu',
    type: 'Typ',
    number: 'Numer',
    startDate: 'Data rozpoczęcia',
    endDate: 'Data zakończenia',
    modificationDate: 'Data modyfikacji',
    title: 'Tytuł',
    openNewWindow: 'Otwórz w nowym oknie',
    addDate: 'Data dodania',
    pok: 'Platforma Obsługi Kampanii',
    help: 'Pomoc',
    instructions: 'Instrukcja',
    openNewCard: 'Otwórz w nowej karcie',
    invoiceType: 'Typ faktury',
    issueDate: 'Data wystawienia',
    saleDate: 'Data sprzedaży',
    exchangeRate: 'Kurs waluty',
    sales: 'Sprzedaż',
    amount: 'Kwota',
    sysError: 'Błąd systemu',
    alertNotifyAdmin:
      'Jeśli zdarzenie będzie się powtarzać, proszę powiadomić Administratora Systemu.',
    contractor: 'Kontrahent',
    recipient: 'Odbiorca',
    responsiblePerson: 'Osoba odpowiedzialna',
    unwrittenData: 'UWAGA: dane nie zostały zapisane',
    contract: 'Zlecenie',
    publisher: 'Dostawca',
    contractTv: 'Zlecenie TV',
    itemsSelected: '{{number}} szt.',
    rangeMonth: 'Zakres miesięcy',
    positionPhase: 'Faza',
    deliveryTeam: 'Zespół realizujący',
    newStartDate: 'Nowa data rozpoczęcia',
    newEndDate: 'Nowa data zakończenia',
    oldStartDate: 'Stara data rozpoczęcia',
    oldEndDate: 'Stara data zakończenia',
    errors: 'Błędy',
    sendDate: 'Data wysłania',
    bulkUpdate: 'Hurtowa edycja',
    bulkUpdateTooltip: 'Wybierz pozycje do hurtowej edycji',
    countryMarket: 'Kraj/rynek',
    noPositions: 'Brak pozycji',
    askImportSelected: 'Czy na pewno zaimportować wybrane pozycje?',
    importSelected: 'Importuj zaznaczone',
    noPositionsSelected: 'Nie wybrano żadnych pozycji do importowania.',
    positionType: 'Typ pozycji',
    nip: 'NIP',
    info: 'Informacja',
    alert: 'Uwaga',
    nameEn: 'Nazwa w j. angielskim',
    phases: 'Fazy',
    communicationChannel: 'Kanał komunikacji',
  },
  component: {
    pointOut: 'Wskaż...',
    enter: 'Wpisz...',
    quickSearch: 'Szybkie wyszukiwanie',
    searchInProgress: 'Trwa wyszukiwanie...',
    numberOfRows: 'Liczba wierszy',
    exportToExcel: 'Eksportuj do pliku Excel',
    exportFileName: 'eksport',
    activeAutomatic: 'Aktywny (automatyczna)',
    cleanFilter: 'Wyczyść filtr',
    noValues: 'Brak wartości',
    selectAll: 'Zaznacz wszystko',
    deselectAll: 'Odznacz wszystko',
    selected: 'Wybrano',
    noCurrency: 'Brak ustawionej waluty w spółce!',
    pleaseWait: 'Proszę czekać...',
  },
  button: {
    clean: 'Wyczyść',
    export: 'Eksportuj',
    close: 'Zamknij',
    save: 'Zapisz',
    delete: 'Usuń',
    add: 'Dodaj',
    edit: 'Edycja',
    addDots: 'Dodaj...',
    open: 'Otwórz',
    cancel: 'Anuluj',
    find: 'Szukaj',
    download: 'Pobierz',
    view: 'Pokaż',
    change: 'Zmień',
    restore: 'Przywróć dane',
    refresh: 'Odśwież',
    update: 'Aktualizuj',
    select: 'Wybierz',
    send: 'Wyślij',
    back: 'Wstecz',
    insert: 'Wstaw',
    next: 'Dalej',
    moveUp: 'Przesuń do góry',
    moveDown: 'Przesuń w dół',
    deleteConfirm: 'Czy na pewno usunąć?',
  },
  attachment: {
    automatic: 'Notatka automatyczna',
    attachments: 'Załączniki',
    attachment: 'Załącznik',
    attachmentNew: 'Nowy załącznik / notatka',
    calculatorCurrency: 'Kalkulator walut',
    note: 'Notatka',
    noteNew: 'Nowa notatka',
    type: 'Typ',
    title: 'Tytuł',
    file: 'Plik',
    invoicing: 'Fakturujący',
    positionsSum: 'Powiązane pozycje - suma zakupu',
    relatedItems: 'Powiązane pozycje',
    addNote: 'Proszę podać notatkę.',
    askDeleteNote: 'Czy na pewno usunąć notatkę?',
    askDeleteAttachment: 'Czy na pewno usunąć załącznik?',
    noteAdded: 'Notatka dodana {{date}}',
    attachmentAdded: 'Załącznik dodany {{date}}',
    chooseFile: 'Wybierz plik',
    deleteAttachment: 'Usuń załącznik',
    deleteNote: 'Usuń notatkę',
    noFileSelected: 'Nie wybrano pliku',
    relatedTo: 'Powiązany z',
    noNotes: 'Brak notatek',
    noAttachments: 'Brak załączników',
    warningAnotherUserNote:
      'Prawdopodobnie inny użytkownik dodał własną notatkę. Zamknij okno i wejdź ponownie w notatkę.',
    newNote: 'Nowa notatka {{text}}',
    editNote: 'Edycja notatki {{text}}',
    comment: 'Komentarz',
    downloadError: 'Błąd przy pobieraniu załączników.',
    FVZLacks: 'Braki FVZ w pozycjach',
    withoutTv: 'Profile oprócz TV',
    withTv: 'TV',
    sendRemindersWithoutTv: 'Wysyłanie przypomnień (oprócz TV)',
    sendRemindersTv: 'Wysyłanie przypomnień (TV)',
    sendMail: 'Wysłanie e-maila',
    fileToLoad: 'Plik do załadowania',
    finance: 'finansów',
    mediaplanner: 'mediaplanera',
    transparentBackgroundRequired:
      'Grafika powinna być w formacie PNG i mieć przezroczyste tło. Jeśli nie widzisz szachownicy pod obrazkiem, wybierz inny plik.',
    encryptedPDF:
      'Uwaga! Dokument PDF jest częściowo zaszyfrowany i nie można go podpisać. Aby to usunąć, otwórz dokument w przeglądarce PDF (np. Adobe Acrobat, Chrome) i wydrukuj go jako nowy plik PDF, zapisując wynikowy dokument. Następnie wgraj nowy niezaszyfrowany załącznik PDF. ',
    estimateItemPurchaseDeficienciesFileName: 'BrakiZakupowe',
    fileSizeExceededWithSize:
      'Łączny rozmiar plików przekracza dozwolony limit {{maxSize}}.',
    fileSizeExceeded: 'Przekroczono dozwolony rozmiar plików.',
    dragAndDropFiles: 'Upuść pliki tutaj...',
    clickToSelectFiles: 'Przeciągnij i upuść pliki lub kliknij aby wybrać',
    supportedFormats: 'Obsługiwane formaty',
    files: 'Pliki',
  },
  email: {
    send: 'Wyślij',
    create: 'Utwórz e-mail',
    recipients: 'Odbiorcy',
    sendToTeam: 'Wyślij e-mail na adres zespołu',
    message: 'Wiadomość',
    sendDate: 'Data wysłania',
    sentFrom: 'Nadawca',
    sentTo: 'Odbiorca',
    subject: 'Temat',
    info: 'Informacja',
    resendToAnotherAddress: 'Ponowne wysłanie na inny adres',
    resendEmail: 'Ponowne wysłanie wiadomości e-mail',
    emailWillBeResentToSpecifiedAddresses:
      'Wiadomość e-mail będzie ponownie wysłana tylko na wskazane poniżej adresy.',
    recipientEmailAddresses: 'Adresy e-mail odbiorców',
    resendEmailQuestion: 'Czy na pewno ponownie wysłać wiadomość e-mail?',
    resendNotAvailableBeforeDate:
      'Ponowne wysłanie jest dostępne tylko dla wiadomości wysłanych od dnia {{date}}.',
    preview: 'Podgląd wiadomości',
    emails: 'Wiadomości e-mail',
    showOnlyNotSent: 'Pokaż tylko niewysłane wiadomości',
    type: 'Typ wiadomości',
    ccEmailAddresses: 'Adresy e-mail DW',
    bccEmailAddresses: 'Adresy e-mail UDW',
    sendingInProgress: 'Trwa wysyłanie wiadomości e-mail...',
    history: 'Historia wysyłki',
    historyTooltip: 'Pokaż historię ponownych wysyłek',
    original: 'Oryginał',
    currentEmail: 'Bieżąca wiadomość',
    noHistory: 'Brak historii ponownych wysyłek dla tej wiadomości.',
    cc: 'DW',
    bcc: 'UDW',
    noData: 'Brak wysłanych wiadomości e-mail',
  },
  memo: {
    loading: 'Trwa ładowanie notatek...',
    createNewMessage: 'Utwórz nową wiadomość do wskazanego użytkownika',
    content: 'Treść',
    giveContent: 'Podaj treść',
    purchaseInvoice: 'Faktura zakupu nr sys.',
    saleInvoice: 'Faktura sprzedaży nr sys.',
    specialInvoicing: 'Niestandardowe fakturowanie nr sys.',
    memosNumber: 'Liczba notatek',
    noMemos: 'Brak notatek',
    information:
      'Notatki związane z {{subject}} będą widoczne w oknie notatek oraz dla wszystkich pracowników spółki. Tylko komentujący użytkownicy będą otrzymywać powiadomienia w przypadku zarejestrowania nowej wiadomości.',
    contentPlhdr: 'Treść...',
    noEmptyMessage: 'Treść wiadomości nie może być pusta',
    all: 'Wszystkie',
    private: 'Prywatne',
    documents: 'Dokumenty',
    threadsCount: 'Liczba wszystkich wątków: ',
    newMessageThreadsCount: 'Liczba wątków z nowymi wiadomościami: ',
    noMessageInSystem:
      'W systemie nie ma jeszcze wiadomości, które możemy tutaj pokazać',
    newMessage: 'Nowa wiadomość',
    turnOff: 'Wyłącz',
    turnOn: 'Włącz',
    newMessageSound: 'dźwięk przychodzącej wiadomości',
    to: 'Do',
  },
  concurrent: {
    editionMode: 'jest w trybie edycji.',
    makingChanges: 'właśnie wprowadza zmiany w danych',
    thisFVS: 'tą fakturą sprzedaży',
    thisFVZ: 'tą fakturą zakupu',
    thisNotStandardInvoices: 'tym niestandardowym fakturowaniem',
  },
  pdfViewer: {
    previousPage: 'Poprzednia strona',
    nextPage: 'Następna strona',
    page: 'Strona',
    of: 'z',
    noTextCopy: 'Skan PDF!',
    loading: 'Trwa ładowanie...',
    noPdfFile: 'Brak pliku PDF',
    error: 'Błąd podczas wczytywania pliku',
    confirmSignaturePointer: 'Zatwierdź miejsce podpisu',
    showSignaturePointer: 'Wskaż miejsce podpisu',
    changeSignaturePointer: 'Zmień miejsce podpisu',
    selectSignaturePlace: 'Wybierz miejsce do podpisu na dokumencie',
    pan: 'Przesuń',
    select: 'Zaznacz',
    signatureLock: 'Blokada podpisu',
  },
  download: {
    downloadDoc: 'Hurtowe pobieranie dokumentów',
    newDownloadDoc: 'Nowe',
    downloadedDoc: 'Pobrane dokumenty',
    downloadedMyDoc: 'Moje pobrane dokumenty',
    creationTs: 'Data utworzenia',
    budgetName: 'Budżet',
    teamName: 'Zespół',
    clientName: 'Kontrahent',
    companyShortname: 'Spółka',
    salesInvoices: 'Faktury sprzedaży',
    salesInvoicesCopies: 'Faktury sprzedaży (kopie)',
    purchaseInvoices: 'Faktury zakupu',
    contracts: 'Zlecenia',
    attachments: 'Załączniki',
    filterName: 'Filtr',
    attachmentsTypes: 'Typy załączników',
    rangeMonths: 'Zakres miesięcy',
    info: 'Informacja',
    waitingDataDownload:
      'Trwa zapisywanie parametrów paczki do wygenerowania ...',
    bulkDownloadsDocuments: 'Zdefiniuj parametry potrzebnych dokumentów',
    downloadInfo: `Wybierz parametry potrzebnych dokumentów. 
    Po kliknięciu przycisku "Eksportuj" rozpocznie się proces tworzenia paczki z dokumentami. 
    Paczka po wygenerowaniu będzie dostępna na zakładce Pobrane dokumenty.`,
    downloadMyInfo: `Wybierz parametry potrzebnych dokumentów. 
    Po kliknięciu przycisku "Eksportuj" rozpocznie się proces tworzenia paczki z dokumentami. 
    Paczka po wygenerowaniu będzie dostępna na zakładce Moje pobrane dokumenty.`,
    needAtLeastOneFilter:
      'Musisz wybrać zespół, budżet, kontrahenta lub kampanię.',
    needSomeTypeDocuments:
      'Musisz wybrać co najmniej jeden typ dokumentów do pobrania.',
    rangeMustBeInSameYear: 'Zakres dat musi dotyczyć tego samego roku.',
    rangeMustBeDefined: 'Zakres miesięcy musi być zdefiniowany.',
    statusWaiting: 'Oczekuje na wyliczenie',
    statusReady: 'Gotowe do pobrania',
    statusCalculating: 'W trakcie wyliczania',
    statusFinished: 'Zakończono',
    notFoundFiles: 'Nie znaleziono danych do pobrania.',
    fileNameDownload: 'Paczka z dokumentami do pobrania',
    noData: 'Brak danych do wyświetlenia',
  },
  invoice: {
    paid: 'Zapłacona',
    withCorrections: 'Z uwzględnieniem korekt',
    withCorrectionsToOriginal: 'Jest korygowana przez',
    otherCorrections: 'Pozostałe korekty',
  },
} as const;
